import axios from 'axios'

export default axios.create({
    // baseURL: 'http://localhost:5030',
    baseURL: process.env.VUE_APP_NOTIFY_API,
    headers: {
        authorization: localStorage.getItem('token')
    },
})
